module.exports = __webpack_public_path__ + "d308073b/img/delete-icon.eb7de062.svg";